export default "__VITE_ASSET__60ee7135__"